import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { ShippingOptionModel } from '../models/shipping-option.model';

export class ShippingOptionsApiService extends ApiService {
  static endpoint = 'shipping-methods/{shipping_method_id}/options';

  /**
   * @param {Number|null} shippingMethodId
   * @return {String}
   * @protected
   */
  static buildShippingMethodUrl(shippingMethodId = null) {
    return this.buildUrl().replace('{shipping_method_id}', shippingMethodId);
  }

  /**
   * @param {String|Number} shippingMethodId
   * @param {String} shippingMethodId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<ShippingMethodModel>>}
   * @public
   */
  static getAll(shippingMethodId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildShippingMethodUrl(shippingMethodId), {
      ...config,
      dataModel: ShippingOptionModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
